'use strict';
module.exports = {
    processError: function(data) {
        const messageError = !Odigeo._.isUndefined(data) && data.messageError;
        const errorLoginExpired = ['AUTH_005', 'AUTH_006', 'SSO_005', 'VAL_052', 'AUTH_100', 'AUTH_101'];
        if (Odigeo._.includes(errorLoginExpired, messageError)) {
            Odigeo.Router.navigate('loginexpired');
        } else {
            Odigeo.Utils.goToApplicationHome();
        }
    },
};
